import { render, staticRenderFns } from "./DepositPoints.vue?vue&type=template&id=e5caceee&scoped=true"
import script from "./DepositPoints.vue?vue&type=script&lang=js"
export * from "./DepositPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5caceee",
  null
  
)

export default component.exports